/* MXDVS photo fit, 22.10.2026 (approved demo "MXDVS Phone Photo Fit", saved settings).
   In the product cards the photos fill the card top to bottom, which cuts a wide product
   (a cap brim, a T-shirt's sleeves) at the sides. This script finds where the product sits in each photo
   (every pixel darker than THRESHOLD counts as product, the white packshot background does not) and,
   only when the full zoom would cut it, zooms the photo out just enough to keep MARGIN free on both sides.
   The space above and below then shows the grey of the card through the same multiply blend.
   It measures a small 200px copy of each photo (one extra small download per photo);
   a photo that cannot be read stays as it is. A square photo in a square card (desktop) always fits, so on
   desktop it only acts on rows with a portrait shape. Loaded by sections/mxdvs-collection.liquid and
   sections/mxdvs-collection-page.liquid when "Zoom photos to fill the shape" is on. */
(function () {
  if (window.MxPhotoFit) return;
  var MARGIN = 0.05;     // space left and right of the product, share of the photo width
  var THRESHOLD = 230;   // darker than this counts as product (0-255)
  var cache = {};

  // Reads a small 200px copy of the photo (Shopify CDN, CORS allowed), so the card photo itself is untouched
  function box(img, done) {
    var src = img.currentSrc || img.src, key;
    try { var u = new URL(src, location.href); u.searchParams.set('width', '200'); key = u.href; } catch (e) { return done(null); }
    if (cache[key] !== undefined) {
      if (cache[key] && cache[key].wait) cache[key].wait.push(done); else done(cache[key]);
      return;
    }
    cache[key] = { wait: [done] };
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    var finish = function (res) { var w = cache[key].wait; cache[key] = res; for (var i = 0; i < w.length; i++) w[i](res); };
    probe.onerror = function () { finish(null); };
    probe.onload = function () {
      try {
        var w = probe.naturalWidth, h = probe.naturalHeight;
        var c = document.createElement('canvas');
        c.width = w; c.height = h;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(probe, 0, 0, w, h);
        var d = x.getImageData(0, 0, w, h).data, l = w, r = -1;
        for (var y = 0; y < h; y++) {
          for (var i = 0; i < w; i++) {
            var p = (y * w + i) * 4;
            if (Math.min(d[p], d[p + 1], d[p + 2]) < THRESHOLD) { if (i < l) l = i; if (i > r) r = i; }
          }
        }
        finish(r < 0 ? null : { l: l / w, r: (r + 1) / w });
      } catch (e) { finish(null); }
    };
    probe.src = key;
  }

  function reset(img) {
    if (!img.classList.contains('is-fit')) return;
    img.classList.remove('is-fit');
    img.style.width = img.style.left = img.style.top = '';
  }

  function fit(img) {
    var media = img.closest('.mx-card__media');
    if (!media || !img.naturalWidth) return;
    box(img, function (b) { place(img, media, b); });
  }

  function place(img, media, b) {
    if (!b) { reset(img); return; }
    var R = media.clientHeight / media.clientWidth;          // card shape (1.25 for 4:5)
    if (!R) return;
    var a = img.naturalWidth / img.naturalHeight;
    var zCover = Math.max(1, R * a);                          // photo width / card width at full zoom
    var z = Math.max(1, Math.min(zCover, 1 / ((b.r - b.l) + 2 * MARGIN)));
    if (z >= zCover - 0.001) { reset(img); return; }          // the product fits: keep the full zoom
    var left = Math.min(0, Math.max(1 - z, 0.5 - z * (b.l + b.r) / 2));
    var top = (R - z / a) / 2 / R;
    img.classList.add('is-fit');
    img.style.width = (z * 100).toFixed(3) + '%';
    img.style.left = (left * 100).toFixed(3) + '%';
    img.style.top = (top * 100).toFixed(3) + '%';
  }

  function run(root) {
    var list = (root || document).querySelectorAll('.mx-col.is-fill .mx-card__img:not(.mx-card__img--alt)');
    for (var i = 0; i < list.length; i++) {
      (function (img) {
        if (img.complete && img.naturalWidth) fit(img);
        else img.addEventListener('load', function () { fit(img); }, { once: true });
      })(list[i]);
    }
  }

  function start() {
    run();
    // products added later (View more, infinite scroll, filters)
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodes = muts[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) if (nodes[j].nodeType === 1) run(nodes[j]);
      }
    }).observe(document.body, { childList: true, subtree: true });
    // turning a tablet or resizing across the phone/desktop line (the card shape changes)
    var mq = window.matchMedia('(max-width: 989px)');
    var onChange = function () { run(); };
    if (mq.addEventListener) mq.addEventListener('change', onChange); else mq.addListener(onChange);
  }

  window.MxPhotoFit = { run: run };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
